import { Text, Box, Link } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { useRef, useEffect } from "react";

//importing icons
import { IoPersonSharp } from "react-icons/io5";
import { FaUserGraduate } from "react-icons/fa";

const iconBoxStyle = {
  padding: "1rem",
  width: "250px",
  borderRadius: "10px",
  border: "1px solid #f4f4f4",
};

export default function TeamMembers() {
  const refContainer = useRef(null);
  useEffect(() => {
    refContainer.current.scrollIntoView({ behavior: "smooth" });
  }, []);
  return (
    <div id="team-members" ref={refContainer}>
      <Box
        padding="1rem"
        background="white"
        marginInlineStart={{ base: "0", md: "0.1rem", xl: "1rem" }}
      >
        <Box textAlign="center">
          <Text fontSize="3xl" fontWeight={700}>
            Team Members
          </Text>
        </Box>

        <Box>
          <Text marginY="10px" textAlign="justify" fontSize="18px">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
            vestibulum hendrerit diam, eu varius lectus rhoncus eu. Cras a
            gravida odio. Cras ultricies felis porttitor pellentesque tempor.
            Curabitur vitae lacus sit amet urna molestie vulputate a vitae enim.
            Donec laoreet sodales vestibulum. Mauris placerat dui sed ex varius
            vestibulum. Cras egestas consectetur dapibus. Ut tincidunt vitae leo
            vel ornare. Pellentesque habitant morbi tristique senectus et netus
            et malesuada fames ac turpis egestas. Pellentesque iaculis tortor a
            placerat maximus. Sed ac felis et sapien gravida molestie. In libero
            eros, vehicula eu lacus in, mattis feugiat arcu. Praesent et dui
            dolor.
          </Text>

          <Box
            display="flex"
            flexDirection={{ base: "column", md: "row" }}
            justifyContent="center"
            alignItems="center"
            width="32%"
            marginX="auto"
            gap="10px"
          >
            <Box
              style={iconBoxStyle}
              boxShadow="md"
              marginX="auto"
              _hover={{
                transition: "box-shadow 0.3s ease-in",
                boxShadow: "lg",
              }}
            >
              <Link
                to="/team-members/current-team-members"
                as={RouterLink}
                style={{ textDecoration: "none" }}
                _focus={{
                  boxShadow: "none",
                }}
                fontSize="18px"
                fontWeight={700}
              >
                <Box display="flex" justifyContent="center" minHeight="150px">
                  <IoPersonSharp fontSize="124px" color="#473198" />
                </Box>
                <Text color="#706d6d" textAlign="center">
                  Current Team Members
                </Text>
              </Link>
            </Box>
            <Box
              style={iconBoxStyle}
              boxShadow="md"
              marginX="auto"
              _hover={{
                transition: "box-shadow 0.3s ease-in",
                boxShadow: "lg",
              }}
            >
              <Link
                to="/team-members/lab-alumni"
                as={RouterLink}
                style={{ textDecoration: "none" }}
                _focus={{
                  boxShadow: "none",
                }}
                fontSize="18px"
                fontWeight={700}
              >
                <Box display="flex" justifyContent="center" minHeight="140px">
                  <FaUserGraduate fontSize="120px" color="#473198" />
                </Box>

                <Text color="#706d6d" textAlign="center" marginTop="10px">
                  Lab Alumni
                </Text>
              </Link>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
}
